import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { getHeadersWithToken } from "src/app/shared/helpers/getHeadersWithToken";
import { environment } from "src/environments/environment";

@Injectable({
  providedIn: "root",
})
export class PaymentsService {
  private readonly _api = environment.apiHost;

  constructor(private _http: HttpClient) {}

  refundSubscriptionAmount(subscriptionId: string) {
    return this._http.patch(
      this._api + `admin/subscription-payments/${subscriptionId}/refund`,
      {},
      {
        headers: getHeadersWithToken(),
      }
    );
  }
}
